import React from 'react';
import {
  StyledWrapper,
  StyledContainer,
  LogoWrapper,
  StyledLogoImage,
  StyledNotice,
  StyledFormContainer
} from './PageTemplate.styles'; 

type Props = {
  logoSrc?: string;
  logoAlt?: string;
  children: React.ReactNode;
  noticeText?: string | null;
  progressBar?: React.ReactNode;
  onLogoClick?: () => void;
  transparent?: boolean;
};

const PageTemplate: React.FC<Props> = ({
  logoSrc,
  logoAlt = 'Logo',
  children,
  noticeText = "If you are eager to learn and schedule a class as a STUDENT, we like your excitement and it is about to launch in couple of days",
  progressBar,
  onLogoClick,
  transparent = false
}) => (
  <StyledWrapper $transparent={transparent}>
    <StyledContainer>
    {logoSrc && 
      <LogoWrapper>
        <StyledLogoImage 
          src={logoSrc} 
          alt={logoAlt} 
          onClick={onLogoClick}
          $clickable={!!onLogoClick}
        />
      </LogoWrapper>
      }
      {/**
      {noticeText && ( 
        <StyledNotice>{noticeText}</StyledNotice>
      )}
       */}
      {progressBar}
      <StyledFormContainer>{children}</StyledFormContainer>
    </StyledContainer>
  </StyledWrapper>
);

export default PageTemplate;
